import React from 'react';
import ReactDOM from 'react-dom';
import App from './App/App';
import './assets/scss/styles.scss';

const initReactFormsApp = () => {
  const mzReactForms = document.querySelectorAll('.mzReactForms');

  if (mzReactForms.length > 0) {
    mzReactForms.forEach((component, index) => {
      const root = component.querySelector('.mz-react-forms-root');
      // Render the App on each mzReactForms.
      ReactDOM.render(
        <React.StrictMode>
          <App />
        </React.StrictMode>,
        root
      );
      // Remove JS and CSS files from the react apps except the first one.
      if (index !== 0) {
        const script = component.querySelector('script');
        const link = component.querySelector('link');
        if (script) script.remove();
        if (link) link.remove();
      }
    })
  }
}

// Check if the JS file for this app hasn't been loaded yet on the site 
if (typeof window.isReactFormsAppLoaded == 'undefined') {
  // Handle init operations of the app.
  initReactFormsApp();
  // Set the flag true.
  window.isReactFormsAppLoaded = true;
}